export const pngMimeTypes = [
  "image/png",
  'image/png; version="1.0"',
  'image/png; version="1.1"',
  'image/png; version="1.2"',
];
